/**
 * 常量
 */

/** AuthNPaas 模块选项 Token */
export const AUTHNPAAS_MODULE_OPTIONS = Symbol('AUTHNPAAS_MODULE_OPTIONS');

/**
 * 元数据键
 */

/** 需要登录元数据键 */
export const NEED_LOGIN_KEY = 'authnpaas:needLogin';
